import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const eocCheckinChatbotElement = css`
	.sectionLabel {
		font-weight: 600;
		margin-bottom: 0.25rem;
	}

	.sectionHelp {
		color: ${colors.infoText};
		font-size: 0.85rem;
		margin-bottom: 0.75rem;
	}

	.settingsRow {
		display: flex;
		gap: 1rem;
		flex-wrap: wrap;
		margin-bottom: 1rem;

		.setting {
			flex: 1 1 180px;
			min-width: 160px;
		}
	}

	.conceptsList {
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
		margin-bottom: 0.75rem;
	}

	.emptyConcepts {
		color: ${colors.infoText};
		font-style: italic;
		margin-bottom: 0.75rem;
	}

	.conceptActions {
		display: flex;
		gap: 0.5rem;
		align-items: center;
		flex-wrap: wrap;
	}
`;

export const keyConceptRow = css`
	border: 1px solid ${colors.border};
	border-radius: 4px;
	padding: 0.75rem;
	background-color: #fff;

	.conceptHeader {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 0.5rem;

		.conceptIndex {
			font-weight: 600;
			color: ${colors.labelText};
			font-size: 0.85rem;
		}

		.removeConcept {
			cursor: pointer;
			color: ${colors.infoText};
			font-size: 1.25rem;

			&:hover {
				color: ${colors.hoverText};
			}
		}
	}

	.fieldLabel {
		font-size: 0.8rem;
		color: ${colors.labelText};
		margin-bottom: 0.15rem;
	}

	.descriptionField {
		margin-top: 0.5rem;
		margin-bottom: 0;
	}
`;
